"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFloatingHeader = void 0;
var _react = require("react");
var useFloatingHeader = tableHeaderRef => {
  var [showFloatingHeader, setShowFloatingHeader] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    var headerEl = tableHeaderRef.current;
    if (!headerEl) return;
    var observer = new window.IntersectionObserver(_ref => {
      var [entry] = _ref;
      setShowFloatingHeader(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, {
      threshold: 0,
      rootMargin: '0px'
    });
    observer.observe(headerEl);
    return () => observer.disconnect();
  }, [tableHeaderRef]);
  return {
    showFloatingHeader
  };
};
exports.useFloatingHeader = useFloatingHeader;